import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Card } from "primereact/card";



export default function ReportTopFilters({
    filters,
    setFilters,
    paramOptions,
    customers
}) {
    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Card className="report-card report-filters-card">
            <div className="report-top">
                <div className="filter-row">
                    <label>From Date</label>
                    <Calendar
                        showIcon
                        dateFormat="dd/mm/yy"
                        value={filters.fromDate}
                        onChange={(e) => handleFilterChange("fromDate", e.value)}
                    />

                    <label className="to-label">To Date</label>
                    <Calendar
                        showIcon
                        dateFormat="dd/mm/yy"
                        value={filters.toDate}
                        onChange={(e) => handleFilterChange("toDate", e.value)}
                    />
                </div>

                <div className="filter-row full">
                    <label>Style No</label>
                    <InputText
                        value={filters.styleNo}
                        onChange={(e) => handleFilterChange("styleNo", e.target.value)}
                        placeholder="Enter Style Number(s), comma separated (e.g. MJH-001, MJH-002)"
                    />
                </div>

                <div className="filter-grid">
                    <div className="filter-item">
                        <label>Customer</label>
                        <MultiSelect
                            options={customers}
                            placeholder="Select Customer"
                            display="chip"
                            filter
                            value={filters.customer}
                            onChange={(e) => handleFilterChange("customer", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Category</label>
                        <MultiSelect
                            options={paramOptions.categories}
                            placeholder="Select Category"
                            display="chip"
                            filter
                            value={filters.category}
                            onChange={(e) => handleFilterChange("category", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Metal</label>
                        <MultiSelect
                            options={paramOptions.metals}
                            placeholder="Select Metal"
                            display="chip"
                            filter
                            value={filters.metal}
                            onChange={(e) => handleFilterChange("metal", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Gold Quality</label>
                        <MultiSelect
                            options={paramOptions.goldQualities}
                            placeholder="Select Gold Quality"
                            display="chip"
                            filter
                            value={filters.goldQuality}
                            onChange={(e) => handleFilterChange("goldQuality", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Price</label>
                        <InputText 
                            value={filters.price}
                            onChange={(e) => handleFilterChange("price", e.target.value)}
                            placeholder="Enter Price Limit"
                        />
                    </div>

                    <div className="filter-item">
                        <label>Diamond Shape</label>
                        <MultiSelect
                            options={paramOptions.diamondShapes}
                            placeholder="Select Shape"
                            display="chip"
                            filter
                            value={filters.diamondShape}
                            onChange={(e) => handleFilterChange("diamondShape", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Diamond Quality</label>
                        <MultiSelect
                            options={paramOptions.diamondQualities}
                            placeholder="Select Quality"
                            display="chip"
                            filter
                            value={filters.diamondQuality}
                            onChange={(e) => handleFilterChange("diamondQuality", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Item Size</label>
                        <MultiSelect
                            options={paramOptions.sizes}
                            placeholder="Select Item Size"
                            display="chip"
                            filter
                            value={filters.itemSize}
                            onChange={(e) => handleFilterChange("itemSize", e.value)}
                        />
                    </div>

                    <div className="filter-item">
                        <label>Collection</label>
                        <MultiSelect
                            options={paramOptions.collections}
                            placeholder="Select Collection"
                            display="chip"
                            filter
                            value={filters.collection}
                            onChange={(e) => handleFilterChange("collection", e.value)}
                        />
                    </div>
                </div>

            </div>
        </Card>
    );
}
